import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isOpen ? _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "persistent": "",
      "width": "540",
      "title": _vm.$i18n_t('Common.multiFactorAuth.dialogTitle')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.cancelBtnText ? _c('core-button', {
          attrs: {
            "data-cy": "2fa_modal_cancel",
            "color": "danger",
            "prepend-icon": _vm.cancelBtnIcon
          },
          on: {
            "click": _vm.emitCloseEvent
          }
        }, [_vm._v("\n      " + _vm._s(_vm.cancelBtnText) + "\n    ")]) : !_vm.isLoginFlow ? _c('core-button', {
          attrs: {
            "color": "danger",
            "prepend-icon": _vm.cancelBtnIcon
          },
          on: {
            "click": _vm.emitCloseEvent
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, false, 1879669831)
  }, [_c(VStepper, {
    attrs: {
      "color": _vm.color,
      "flat": "",
      "non-linear": ""
    },
    model: {
      value: _vm.setupStep,
      callback: function ($$v) {
        _vm.setupStep = $$v;
      },
      expression: "setupStep"
    }
  }, [_c(VStepperHeader, [_c(VStepperStep, {
    attrs: {
      "complete": _vm.setupStep > 1,
      "step": "1",
      "color": _vm.color
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.stepperScan')) + "\n      ")]), _c(VDivider), _c(VStepperStep, {
    attrs: {
      "complete": _vm.setupStep > 2,
      "step": "2",
      "color": _vm.color
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.stepperEnterCode')) + "\n      ")]), _c(VDivider), _c(VStepperStep, {
    attrs: {
      "complete": _vm.setupStep > 3,
      "step": "3",
      "color": _vm.color
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.stepperFinish')) + "\n      ")])], 1), _c(VStepperItems, [_c(VStepperContent, {
    attrs: {
      "step": "1"
    }
  }, [_vm.isLoginFlow ? [_c('p', [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.loginFlow_p1')) + "\n          ")])] : _vm._e(), _vm.qrImage ? _c('img', {
    staticStyle: {
      "display": "block",
      "margin": "0 auto 16px auto"
    },
    attrs: {
      "src": _vm.qrImage,
      "width": "200"
    }
  }) : _vm.isLoadingQr ? _c(VProgressCircular, {
    staticStyle: {
      "display": "block",
      "margin": "16px auto 16px auto"
    },
    attrs: {
      "color": _vm.color,
      "indeterminate": "",
      "width": "5",
      "size": "75"
    }
  }) : _c(VAlert, {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.scanQrCode_error')) + "\n        ")]), _c('p', [_vm._v(_vm._s(_vm.$i18n_t('Common.multiFactorAuth.scanQrCode_p1')))]), _c('p', [_vm._v(_vm._s(_vm.$i18n_t('Common.multiFactorAuth.scanQrCode_p2')))]), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "end"
    }
  }, [_vm.errorQrCode ? _c('core-button', {
    attrs: {
      "data-cy": "2fa_modal_step1_retry",
      "color": _vm.color
    },
    on: {
      "click": _vm.getQRCode
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.scanQrCode_retry')) + "\n          ")]) : _vm._e(), _c('core-button', {
    attrs: {
      "data-cy": "2fa_modal_step1_continue",
      "color": _vm.color,
      "append-icon": "fa-arrow-right",
      "disabled": !_vm.qrImage || _vm.isLoadingQr || _vm.errorQrCode
    },
    on: {
      "click": _vm.handleQrCodeScanned
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.scanQrCode_btn')) + "\n          ")])], 1)], 2), _c(VStepperContent, {
    attrs: {
      "step": "2"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('Common.multiFactorAuth.verifyToken_p2')))]), _c('div', {
    attrs: {
      "data-cy": "2fa_modal_step2_input"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": "",
      "autofocus": "",
      "error": _vm.errorVerify,
      "label": _vm.$i18n_t('Common.multiFactorAuth.verifyTokenInputLabel'),
      "maxlength": 6,
      "error-messages": _vm.errorVerify ? _vm.$i18n_t(_vm.verifyErrorMessageKey) : ''
    },
    on: {
      "input": _vm.handleCodeChanged,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleCodeEntered.apply(null, arguments);
      }
    },
    model: {
      value: _vm.inputVerifyToken,
      callback: function ($$v) {
        _vm.inputVerifyToken = $$v;
      },
      expression: "inputVerifyToken"
    }
  })], 1), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "end"
    }
  }, [_c('core-button', {
    attrs: {
      "data-cy": "2fa_modal_step2_verify",
      "color": _vm.color,
      "append-icon": "fa-arrow-right",
      "disabled": _vm.inputVerifyToken.length !== 6 || _vm.isVerifying
    },
    on: {
      "click": _vm.handleCodeEntered
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.verifyToken_btn')) + "\n          ")])], 1)]), _c(VStepperContent, {
    attrs: {
      "step": "3"
    }
  }, [_c('p', [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.recoveryCodes_p2')) + "\n        ")]), _vm.errorComplete ? _c(VAlert, {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "error",
      "data-cy": "2fa_modal_step3_error"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t(_vm.completeErrorMessageKey)) + "\n        ")]) : _vm._e(), _c('div', {
    staticStyle: {
      "background-color": "#f5f5f5",
      "padding": "16px",
      "margin-bottom": "16px"
    }
  }, [_c('ul', {
    staticClass: "recovery-codes"
  }, _vm._l(_vm.recoveryCodes, function (code, index) {
    return _c('li', {
      key: `key-${index}`
    }, [_vm._v("\n              " + _vm._s(code) + "\n              "), _c('br')]);
  }), 0), _c(VBtn, {
    staticStyle: {
      "padding": "0 !important",
      "margin-top": "16px !important"
    },
    attrs: {
      "data-cy": "2fa_modal_step3_copy",
      "color": _vm.color,
      "text": "",
      "small": ""
    },
    on: {
      "click": _vm.copyCodesToClipboard
    }
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-copy")]), _vm._v("\n             " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.copyRecoveryCodes_btn')) + "\n          ")], 1)], 1), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "end"
    }
  }, [_c('core-button', {
    attrs: {
      "data-cy": "2fa_modal_step3_finish",
      "color": _vm.color,
      "append-icon": "fa-arrow-right",
      "disabled": _vm.isCompleting
    },
    on: {
      "click": _vm.handleFinishClicked
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.recoveryCodes_btn')) + "\n          ")])], 1)], 1)], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };